import React, { memo } from 'react';
import cn from 'classnames';
import { NavLinkProps, Route } from '@medlinker/fundamental';
import MedLink from '../MedLink';

interface Props extends NavLinkProps {
  to: string;
  activeClassName: string;
  className: string;
}

function MedNavLink(props: Props) {
  const { className, activeClassName, exact, to, ...rest } = props;
  const routeTo = to.split('?')[0];

  return (
    <Route
      exact={exact}
      path={routeTo}
      children={({ match }) => {
        return (
          // @ts-ignore
          <MedLink
            {...rest}
            to={props.to}
            className={cn(className, match ? activeClassName : '')}
          />
        );
      }}
    />
  );
}

export default memo(MedNavLink);
